<div class="loading">
  <img id="loading-logo" src="./assets/logo-k.png">
  <h3>Authenticating</h3>
</div>
